// src/hooks/useAuth.ts
"use client"

import { useCallback } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useRouter } from "@tanstack/react-router"

//import { PendingMessage } from "@/components/community/message-approval";
import { clearSentryIdentity } from "@/observability/sentry-identity"
import { useOpenReplayIdentity } from "./use-openreplay-identity"
import { useSentryIdentity } from "./use-sentry-identity"
import { getGetAuthUserQueryKey, useGetAuthUser } from "openapi/api/endpoints"
import { AXIOS_INSTANCE } from "openapi/mutator/custom-client"

function useAuthUserIdentity() {
  const authQuery = useGetAuthUser({
    query: {
      retry: false,
    },
  })

  useSentryIdentity(authQuery.data)
  useOpenReplayIdentity(authQuery.data)

  return authQuery
}

function useLogoutAction() {
  const router = useRouter()
  const queryClient = useQueryClient()

  return useCallback(async () => {
    localStorage.removeItem("currentOrganization")
    await AXIOS_INSTANCE.post("/auth/logout")
    queryClient.setQueryData(getGetAuthUserQueryKey(), null)
    clearSentryIdentity()
    await router.navigate({ to: "/authentication", replace: true })
    window.location.href = "/authentication" // force reload to authentication page after logout
  }, [queryClient, router])
}

export function useAuth() {
  const { data: user, isLoading } = useAuthUserIdentity()
  const logout = useLogoutAction()

  /* const loginWithGoogle = () => {
    window.location.href = "http://localhost:5001/auth/login/google";
  };

  const loginWithMicrosoft = () => {
    window.location.href = "http://localhost:5001/auth/login/azure";
  }; */

  return {
    user,
    isLoading,
    //loginWithGoogle,
    //loginWithMicrosoft,
    logout,
  }
}

// simple helper to send an email
/* export async function sendEmail(email: PendingMessage) {
  try {
    await AXIOS_INSTANCE.post("/api/send-email", {
      recipientEmail: email.recipientEmail,
      subject: email.subject,
      message: email.content,
    });
  } catch (err: any) {
    console.log("Email error: ", err);
    throw err;
  }
}
 */
